import { render, staticRenderFns } from "./StatisticsSubject.vue?vue&type=template&id=664c3313"
import script from "./StatisticsSubject.vue?vue&type=script&lang=js"
export * from "./StatisticsSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports